var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBills1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 2.75949C7.25 2.34004 7.58579 2 8 2H16C16.4142 2 16.75 2.34004 16.75 2.75949C16.75 3.17895 16.4142 3.51899 16 3.51899H8C7.58579 3.51899 7.25 3.17895 7.25 2.75949Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.79746C4.25 5.378 4.58579 5.03796 5 5.03796H19C19.4142 5.03796 19.75 5.378 19.75 5.79746C19.75 6.21692 19.4142 6.55695 19 6.55695H5C4.58579 6.55695 4.25 6.21692 4.25 5.79746Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.8481C2 8.72955 2.89543 7.82278 4 7.82278H20C21.1046 7.82278 22 8.72955 22 9.8481V19.9747C22 21.0932 21.1046 22 20 22H4C2.89543 22 2 21.0932 2 19.9747V9.8481ZM15 14.9114C15 13.2336 13.6569 11.8734 12 11.8734C10.3431 11.8734 9 13.2336 9 14.9114C9 16.5892 10.3431 17.9494 12 17.9494C13.6569 17.9494 15 16.5892 15 14.9114ZM5 18.2025C4.58579 18.2025 4.25 18.5426 4.25 18.962C4.25 19.3815 4.58579 19.7215 5 19.7215H8C8.41421 19.7215 8.75 19.3815 8.75 18.962C8.75 18.5426 8.41421 18.2025 8 18.2025H5ZM15.25 10.8608C15.25 11.2802 15.5858 11.6203 16 11.6203H19C19.4142 11.6203 19.75 11.2802 19.75 10.8608C19.75 10.4413 19.4142 10.1013 19 10.1013H16C15.5858 10.1013 15.25 10.4413 15.25 10.8608Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills1);
export default __webpack_public_path__ + "static/media/bills-1.00bc09e15847aa342ac6c34b38830b98.svg";
export { ForwardRef as ReactComponent };